import { styled } from '@mui/material/styles'
import { Layout, LayoutProps } from 'react-admin'
import AppBar from './AppBar'
import Menu from './Menu'
import Sidebar from './Sidebar'

const layout = ({ children, ...props }: LayoutProps): JSX.Element => (
  <StyledLayout
    {...props}
    appBar={AppBar}
    sidebar={Sidebar}
    menu={Menu}
    className={classes.content}
  >
    {children}
  </StyledLayout>
)

const PREFIX = 'xxllncLayout'

const classes = {
  content: `${PREFIX}-content`,
}

const StyledLayout = styled(Layout)(({ theme }) => ({
  [`&.${classes.content}`]: {
    position: 'relative',
    padding: 0,
    // A flex item of the page: without this a wide child (a row of tabs) stretches the page past a phone's width.
    minWidth: 0,
    // Flex items down to the page card: a wide form child must scroll or wrap, not widen the page.
    ['& .RaCreate-card, & .RaEdit-card, & .RaLayout-appFrame, & .RaLayout-contentWithSidebar, & .RaLayout-content']: {
      minWidth: 0,
    },
    ['& #main-content']: {
      position: 'relative',
    },
  },
}))

export default layout
